import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=374d32b1&scoped=true&"
var script = {}
import style0 from "./dashboard.vue?vue&type=style&index=0&id=374d32b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374d32b1",
  null
  
)

export default component.exports